import * as actionTypes from '@store/actions/actionTypes'
import { defaultPropEvalFilterVals } from '@util/constants'

const initialState = {
  subjectProperty: null,
  forSaleFilters: defaultPropEvalFilterVals,
  soldFilters: defaultPropEvalFilterVals
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_SUBJECT_PROPERTY:
      return {
        ...state,
        subjectProperty: action.property
      }
    case actionTypes.SET_FORSALE_COMPS:
      return {
        ...state,
        forSaleComps: action.forSaleComps
      }
    case actionTypes.SET_SOLD_COMPS:
      return {
        ...state,
        soldComps: action.soldComps
      }
    case actionTypes.SET_OFFMARKET_COMPS:
      return {
        ...state,
        offMarketComps: action.offMarketComps
      }
    case actionTypes.SET_AVMS:
      return {
        ...state,
        avms: action.avms
      }
    case actionTypes.SET_PROPEVAL_FILTERS:
      return {
        ...state,
        filters: action.filters
      }
    case actionTypes.SET_FOR_SALE_FILTERS:
      return {
        ...state,
        forSaleFilters: action.filters
      }
    case actionTypes.SET_SOLD_FILTERS:
      return {
        ...state,
        soldFilters: action.filters
      }
    case actionTypes.RESET_SOLD_FILTERS:
      return {
        ...state,
        soldFilters: action.defaults || initialState.soldFilters
      }
    case actionTypes.RESET_FOR_SALE_FILTERS:
      return {
        ...state,
        forSaleFilters: action.defaults || initialState.forSaleFilters
      }
    case actionTypes.SET_PROP_EVAL_HEADER:
      return {
        ...state,
        propEvalHeader: action.bool
      }
    case actionTypes.RESET_PROP_EVAL:
      return {
        ...initialState,
        avms: null,
        comps: null,
        cmas: null
      }
    default:
      return state
  }
}

export default reducer
